import { MtProjectGroup, MtUser } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { ProjectGroupFilters, UserFilters } from "client/store"
import * as types from "./types"


export const setProjectUserGroupList = (userGroupList: types.ProjectUserGroupList) => ({
    type: inferLiteral(types.PROJECT_USER_GROUP_LIST),
    userGroupList,
})
export const setProjectGroupUserList = (groupUserList: types.ProjectGroupUserList) => ({
    type: inferLiteral(types.PROJECT_GROUP_USER_LIST),
    groupUserList,
})

// project user groups

export const setAssignedProjectUserGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_GROUP_IDS),
    groupIds,
})
export const setAssignedProjectUserGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedProjectUserGroupFilters = (filters: ProjectGroupFilters) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_GROUP_FILTERS),
    filters,
})
export const setNotAssignedProjectUserGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_GROUP_IDS),
    groupIds,
})
export const setNotAssignedProjectUserGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedProjectUserGroupFilters = (filters: ProjectGroupFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_GROUP_FILTERS),
    filters,
})
export const setNotAssignedProjectUserGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_GROUP_SELECTED),
    selected,
})

// project group users

export const setAssignedProjectGroupUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_GROUP_USER_IDS),
    userIds,
})
export const setAssignedProjectGroupUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_GROUP_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedProjectGroupUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_GROUP_USER_FILTERS),
    filters,
})
export const setNotAssignedProjectGroupUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_GROUP_USER_IDS),
    userIds,
})
export const setNotAssignedProjectGroupUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_GROUP_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedProjectGroupUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_GROUP_USER_FILTERS),
    filters,
})
export const setNotAssignedProjectGroupUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_GROUP_USER_SELECTED),
    selected,
})

// reload lists

export const setProjectUserGroupReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_USER_GROUP_RELOAD_LIST),
    value,
})
export const setProjectGroupUserReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_GROUP_USER_RELOAD_LIST),
    value,
})
